import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const TermAndContions = () => {
  return (
    <>
      <Container className="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="policy">
              <h1>Terms & Conditions</h1>

              <p>
                For the purpose of these Terms and Conditions, The term "we", "us",
                "our" used anywhere on this page shall mean{" "}
                <strong>ASTRAPE. AI PRIVATE LIMITED</strong>, whose
                registered/operational office is 21ST FLOOR, 2104, C-WING RAHEJA
                RIDGEWOOD, Goregaon East Mumbai Goregaon East Maharashtra India
                400063 Sharma Estate SO MAHARASHTRA 400063. "you", “your”, "user”,
                “visitor” shall mean any natural or legal person who is visiting our
                website and/or agreed to purchase from us.
              </p>

              <p>
                Your use of the website and/or purchase from us are governed by the
                following Terms and Conditions:
              </p>

              <p>The content of the pages of this website is subject to change without notice.</p>

              <p>
                Neither we nor any third parties provide any warranty or guarantee as
                to the accuracy, timeliness, performance, completeness or suitability
                of the information and materials found or offered on this website for
                any particular purpose. You acknowledge that such information and
                materials may contain inaccuracies or errors and we expressly exclude
                liability for any such inaccuracies or errors to the fullest extent
                permitted by law.
              </p>

              <p>
                Your use of any information or materials on our website and/or product
                pages is entirely at your own risk, for which we shall not be liable.
                It shall be your own responsibility to ensure that any products,
                services or information available through our website and/or product
                pages meet your specific requirements.
              </p>

              <p>
                Our website contains material which is owned by or licensed to us.
                This material includes, but is not limited to, the design, layout,
                look, appearance and graphics. Reproduction is prohibited other than
                in accordance with the copyright notice, which forms part of these
                terms and conditions.
              </p>

              <p>
                All trademarks reproduced in our website which are not the property of,
                or licensed to, the operator are acknowledged on the website.
              </p>

              <p>
                Unauthorized use of information provided by us shall give rise to a
                claim for damages and/or be a criminal offense.
              </p>

              <p>
                From time to time our website may also include links to other
                websites. These links are provided for your convenience to provide
                further information.
              </p>

              <p>
                You may not create a link to our website from another website or
                document without ASTRAPE. AI PRIVATE LIMITED’s prior written consent.
              </p>

              <p>
                Any dispute arising out of use of our website and/or purchase with us
                and/or any engagement with us is subject to the laws of India.
              </p>

              <p>
                We shall be under no liability whatsoever in respect of any loss or
                damage arising directly or indirectly out of the decline of
                authorization for any Transaction, on account of the Cardholder having
                exceeded the preset limit mutually agreed by us with our acquiring bank
                from time to time.
              </p>

              <p>
                <strong>Disclaimer:</strong> The above content is created at ASTRAPE.
                AI PRIVATE LIMITED&apos;s sole discretion. Razorpay shall not be
                liable for any content provided here and shall not be responsible for
                any claims and liability that may arise due to merchant’s
                non-adherence to it.
              </p>

              <p>
                <a href="/">Back to Home</a>
              </p>

              <footer className="mt-4">
                <p>© 2025 Astrape.AI Pvt Ltd | All rights reserved</p>
                <p>
                  <a href="/cancellation-refund" className="policy">
                    Cancellation & Refund
                  </a>{" "}
                  |{" "}
                  <a href="/terms-and-conditions" className="policy">
                    Terms & Conditions
                  </a>{" "}
                  |{" "}
                  <a href="/shipping-delivery" className="policy">
                    Shipping & Delivery
                  </a>{" "}
                  |{" "}
                  <a href="/privacy" className="policy">
                    Privacy
                  </a>
                </p>
              </footer>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default TermAndContions;
